const menuList = [
  {
    menuId: 1,
    parentId: 0,
    title: "ลงลายมือชื่ออิเล็กทรอนิกส์",
    titleCollapse: "ลงลายมือ",
    iconClass: ["fa-solid", "fa-file-signature"],
    auth: ["auth_sign"],
    to: "Signature",
  },
  {
    menuId: 7,
    parentId: 0,
    title: "รายการเอกสารรอลงลายมือชื่อฯ",
    titleCollapse: "เอกสารรอลงลายมือชื่อ",
    iconClass: ["fa-solid", "fa-file-import"],
    auth: ["auth_waiting"],
    to: "SignatureWaiting",
  },
  {
    menuId: 2,
    parentId: 0,
    title: "ประวัติเอกสารการลงลายมือชื่ออิเล็กทรอนิกส์",
    titleCollapse: "ประวัติเอกสารการลงลายมือ",
    iconClass: ["fa-solid", "fa-file-waveform"],
    auth: ["auth_hissign"],
    to: "HistorySignature",
  },
  {
    menuId: 8,
    parentId: 0,
    title: "จัดการเอกสารรอลงลายมือชื่ออิเล็กทรอนิกส์",
    titleCollapse: "จัดการเอกสาร",
    iconClass: ["fa-solid", "fa-file-import"],
    auth: ["auth_waiting_manage"],
    to: "SignatureManage",
  },
  {
    menuId: 3,
    parentId: 0,
    title: "จัดการรูปลายมือชื่อ",
    titleCollapse: "รูปลายมือชื่อ",
    iconClass: ["fa-solid", "fa-signature"],
    auth: ["auth_managesign"],
    to: "ManageSign",
  },
  {
    menuId: 4,
    parentId: 0,
    title: "ข้อมูลผู้ใช้งานระบบ",
    titleCollapse: "ข้อมูลผู้ใช้งานระบบ",
    iconClass: ["fas", "user"],
    auth: ["auth_system"],
    hasSub: true,
  },
  {
    menuId: 5,
    parentId: 4,
    title: "ผู้ใช้งาน",
    titleCollapse: "ผู้ใช้งาน",
    auth: ["auth_system"],
    to: "UserList",
  },
  {
    menuId: 6,
    parentId: 4,
    title: "ประวัติการใช้งานระบบ",
    titleCollapse: "ประวัติ",
    auth: ["auth_system"],
    to: "HistoryUse",
  },
];

const menuListUpload = [
  {
    menuId: 8,
    parentId: 0,
    title: "จัดการเอกสารรอลงลายมือชื่ออิเล็กทรอนิกส์",
    titleCollapse: "จัดการเอกสาร",
    iconClass: ["fa-solid", "fa-file-import"],
    auth: ["auth_waiting_manage"],
    to: "SignatureManage",
  },
];

const menuListSigner = [
  {
    menuId: 1,
    parentId: 0,
    title: "ลงลายมือชื่ออิเล็กทรอนิกส์",
    titleCollapse: "ลงลายมือ",
    iconClass: ["fa-solid", "fa-file-signature"],
    auth: ["auth_sign"],
    to: "Signature",
  },
  {
    menuId: 7,
    parentId: 0,
    title: "รายการเอกสารรอลงลายมือชื่อฯ",
    titleCollapse: "เอกสารรอลงลายมือชื่อ",
    iconClass: ["fa-solid", "fa-file-import"],
    auth: ["auth_waiting"],
    to: "SignatureWaiting",
  },
  {
    menuId: 2,
    parentId: 0,
    title: "ประวัติเอกสารการลงลายมือชื่ออิเล็กทรอนิกส์",
    titleCollapse: "ประวัติเอกสารการลงลายมือ",
    iconClass: ["fa-solid", "fa-file-waveform"],
    auth: ["auth_hissign"],
    to: "HistorySignature",
  },
  {
    menuId: 3,
    parentId: 0,
    title: "จัดการรูปลายมือชื่อ",
    titleCollapse: "รูปลายมือชื่อ",
    iconClass: ["fa-solid", "fa-signature"],
    auth: ["auth_managesign"],
    to: "ManageSign",
  },
  {
    menuId: 8,
    parentId: 0,
    title: "จัดการเอกสารรอลงลายมือชื่ออิเล็กทรอนิกส์",
    titleCollapse: "จัดการเอกสาร",
    iconClass: ["fa-solid", "fa-file-import"],
    auth: ["auth_waiting_manage"],
    to: "SignatureManage",
  },
];

const state = {
  menus: [...menuList],
  menuListUpload: [...menuListUpload],
  menuListSigner: [...menuListSigner],
};

export const menus = {
  namespaced: true,
  state,
};
